
      if (import.meta.env.VITE_REGION === 'china') {
        // China: Load from local public folder (removed crossorigin and referrer to get rid of cors error)
        // !IMP: Update supabase monthly to latest version in china
        var script = document.createElement('script');
        script.src = '/supabase-js@2.45.1-cn/supabase.js';
        script.onload = () => (window.supabase = supabase);
        document.getElementsByTagName('head')[0].appendChild(script);
      } else {
        // Global: Load from unpkg CDN
        // !IMP: Loading supabase on global as well since pamoja poc case where students from china access global managebac and hence global assessprep - we set region based on timezone in that case
        var script = document.createElement('script');
        script.src = 'https://unpkg.com/@supabase/supabase-js@2';
        script.onload = () => (window.supabase = supabase);
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    